import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import * as atoms from '../../../atoms/atoms';
import useAccountPermission from '../../../hooks/useAccountPermission';
import useCachedEnvironments from '../../../hooks/useCachedEnvironments';
import { isInSaaSMode } from '../../../utils/common';
import { CHAT_MODES } from '../constants';
import { ChatMode } from '../types';

const ALL_MODES = CHAT_MODES.map((m) => m.key);

const useAvailableModes = (): ChatMode[] => {
  const selectedEnvId = useRecoilValue(atoms.selectedEnvironmentId);
  const { data: environmentsData } = useCachedEnvironments();
  const hasAccountPermission = useAccountPermission();
  const canCreateEnvironments = hasAccountPermission('CREATE_ENVIRONMENTS');

  return useMemo((): ChatMode[] => {
    if (!isInSaaSMode()) {
      return ALL_MODES;
    }

    if (environmentsData?.length === 0) {
      return canCreateEnvironments ? ALL_MODES : ['ask'];
    }

    const chatModes = environmentsData?.find(
      (env) => env.id === selectedEnvId,
    )?.chatModes;

    if (!chatModes) {
      return ['ask'];
    }

    return ALL_MODES.filter((mode) => chatModes.includes(mode));
  }, [canCreateEnvironments, environmentsData, selectedEnvId]);
};

export default useAvailableModes;
